export default "b7fdbfbe9a4be554.svg"